import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import LeadDashboard from './LeadDashboard';
import UserSessionManager from '../../utils/UserSessionManager';

const Dashboard = () => {
  const navigate = useNavigate();
  const [dashboardView, setDashboardView] = useState('main');

  useEffect(() => {    
    const token = localStorage.getItem('accessToken');
    if (!token) {
      navigate('/signin');
      return;
    }

    const session = UserSessionManager.getSession();
    const userType = session?.userType?.toLowerCase() || 'lead';

    if (userType.includes('admin')) {
      setDashboardView('admin');
    } else {
      setDashboardView('lead');
    }
  }, []);

  return (
    <>
      {dashboardView === 'admin' ? <AdminDashboard /> : <LeadDashboard />}
    </>
  );
};

export default Dashboard;